import React, { useEffect } from 'react';
import { Lock, UserCheck, Key } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const Security = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('security');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'Permissions',
      icon: Lock,
      description: 'Audit user permissions, role memberships, and access rights across your SQL Server instances.',
      scripts: getContentByCategory('Security', 'Permissions')
    },
    {
      name: 'Authentication',
      icon: UserCheck,
      description: 'Monitor login security, password policies, and authentication-related security settings.',
      scripts: getContentByCategory('Security', 'Authentication')
    },
    {
      name: 'Encryption',
      icon: Key,
      description: 'Manage and monitor data encryption, certificates, and cryptographic security features.',
      scripts: getContentByCategory('Security', 'Encryption')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Security Auditing</h1>
        <p className="page-description">
          Essential security scripts to help you audit permissions, monitor authentication, 
          and ensure your SQL Server instances are properly secured against threats.
        </p>
      </div>

      <CategoryTabs 
        category="Security"
        scripts={getContentByCategory('Security')}
        articles={getContentByCategory('Security', null, 'articles')}
        faqs={getContentByCategory('Security', null, 'faqs')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default Security;